import { config } from "../config";
import { log } from "@soulbyte/core";
import {
  createI18n,
  languages,
  type LanguageStorageClient,
} from "@soulbyte/i18n";
import { resources } from "./resources";

export const i18nConfig = {
  key: `${config.key}.language`,
};

export const languageStorage: LanguageStorageClient = {
  onError: (error, context) => {
    log.error(error, {
      extra: {
        key: i18nConfig.key,
        phase: context.phase,
        language: context.language,
      },
      disableTracking: true,
    });
  },
  getLanguage: () => localStorage.getItem(i18nConfig.key),
  setLanguage: (language) => localStorage.setItem(i18nConfig.key, language),
};

const i18n = createI18n({
  storage: languageStorage,
  resources,
  initialLanguage: "de",
});

export default i18n;
export { languages, resources };
